var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBalance = function SvgBalance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M80.67 44A36.67 36.67 0 0 1 44 80.67l1.95-3.25a29.33 29.33 0 0 0 0-30.18l-3.9-6.48a29.33 29.33 0 0 1 0-30.18L44 7.32A36.67 36.67 0 0 1 80.67 44ZM56.83 33a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M37.21 7.96a36.68 36.68 0 0 0 .68 72.2l3.08-5.14a31.17 31.17 0 0 1-6.72-60.63l.07-.21s1.71-4.22 2.9-6.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M31.17 62.33a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
  })));
};
export default SvgBalance;